<template>
  <div :class="'verified-badge' + getSizeClass">
    <el-tooltip
      effect="dark"
      placement="top"
      content="This artist has been verified"
      v-if="showTooltip"
      ><img src="/img/icons/verified-badge.png" alt="Verified badge"
    /></el-tooltip>
    <img v-else src="/img/icons/verified-badge.png" />
  </div>
</template>

<script>
export default {
  name: "verified-badge",
  props: {
    showTooltip: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "md",
    },
  },
  computed: {
    getSizeClass() {
      return ` verified-badge-${this.size}`;
    },
  },
};
</script>

<style scoped lang="scss">
.verified-badge {
  flex: 1;
  display: inline;
  vertical-align: text-bottom;

  // Size md
  img {
    width: 26px;
    height: 26px;
    margin-left: 6px;
  }

  // Size xs
  &-xs {
    img {
      margin-left: 2px;
      width: 12px;
      height: 12px;
    }
  }

  // Size sm
  &-sm {
    img {
      margin-left: 2px;
      width: 20px;
      height: 20px;
    }
  }

  // Size smmd
  &-smmd {
    img {
      margin-left: 2px;
      width: 16px;
      height: 16px;
    }
  }

  // Size lg
  &-lg {
    img {
      margin-left: 2px;
      width: 36px;
      height: 36px;
    }
  }
}

@media (max-width: 575.98px) {
  .verified-badge {
    img {
      width: 22px;
      height: 22px;
    }

    // Size xs
    &-xs {
      img {
        width: 12px;
        height: 12px;
      }
    }

    // Size sm
    &-sm {
      img {
        margin-left: 4px;
        width: 18px;
        height: 18px;
      }
    }

    // Size smmd
    &-smmd {
      img {
        margin-left: 2px;
        width: 14px;
        height: 14px;
      }
    }

    // Size smmd
    &-lg {
      img {
        margin-left: 2px;
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
